var React = require('react');

function NewsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25 15.625H28.125M25 21.875H28.125M12.5 28.125H28.125M12.5 34.375H28.125M34.375 15.625H41.4062C42.7 15.625 43.75 16.675 43.75 17.9687V37.5C43.75 38.7432 43.2561 39.9355 42.3771 40.8146C41.498 41.6936 40.3057 42.1875 39.0625 42.1875M34.375 15.625V37.5C34.375 38.7432 34.8689 39.9355 35.7479 40.8146C36.627 41.6936 37.8193 42.1875 39.0625 42.1875M34.375 15.625V10.1562C34.375 8.8625 33.325 7.8125 32.0312 7.8125H8.59375C7.3 7.8125 6.25 8.8625 6.25 10.1562V37.5C6.25 38.7432 6.74386 39.9355 7.62294 40.8146C8.50201 41.6936 9.6943 42.1875 10.9375 42.1875H39.0625M12.5 15.625H18.75V21.875H12.5V15.625Z","stroke":"#938DCD","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round"}));
}

NewsInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = NewsInline;

NewsInline.default = NewsInline;
